const initState = {
    err: null
};

const apiReducer = (state = initState, action) => {
    // console.log("apiReducer::\nactionType=" + action.type);
    // console.log(action.data);
    switch (action.type) {
        case "COURSES_TAKE_BY_USER":
            return {
                ...state,
                courses: action.data
            };
        case "COURSE_BY_URL":
            return {
                ...state,
                course: action.data
            };
        case "GET_COURSE_OVERVIEW":
            return {
                ...state,
                payload: action.data
            };
        case "GET_COURSE_DETAIL":
            return {
                ...state,
                payload: action.data
            }
        case "TAKE_COURSE":
            return state;
        default:
            return state;
    }
};

export default apiReducer;
